import endpoints from '../../../../shared/constants/endpoints';

/** Menu category anchor for Catering (matches menu section slug / id). */
export const GIFTING_MENU_CATERING_SECTION_LINK = '/menu#catering';

/** Event terms & conditions (footer / TermsAndConditions cookielab CMS page). */
export const GIFTING_EVENT_TERMS_AND_CONDITIONS_LINK = endpoints.cookielabTerms;

/** Default copy for reviews + corporate block; override via props when CMS is wired. */
export const GIFTING_REVIEWS_CORPORATE_DEFAULT = {
  reviews: [
    {
      id: 'martha-c',
      author: 'Martha C.',
      quote:
        '"They arrived warm at 11pm with a note. Better than flowers, and she agrees."',
    },
    {
      id: 'finals-gift',
      author: 'Jamie R.',
      quote:
        '"Sent these to my daughter during finals, such a great gift idea."',
    },
    {
      id: 'client-thanks',
      author: 'Alex T.',
      quote:
        '"Ordered 10 boxes as client thank-you, the team didn\'t leave a crumb."',
    },
  ],
  reviewRotationMs: 6000,
  corporateEyebrow: 'Corporate & Bulk',
  corporateHeadline: "Gift the whole office. We'll do the hard part.",
  corporateBody:
    'Client thank-yous, team drops, event catering, and more. Need something custom? Our corporate team has you covered.',
  primaryCtaText: 'Order Catering',
  primaryCtaLink: GIFTING_MENU_CATERING_SECTION_LINK,
  primaryCtaButtonType: 'internal_link',
  secondaryCtaText: 'Learn More',
  secondaryCtaLink: GIFTING_EVENT_TERMS_AND_CONDITIONS_LINK,
  secondaryCtaButtonType: 'internal_link',
  contentSectionReviews: 'Gifting LP — Reviews',
  contentSectionCorporate: 'Gifting LP — Corporate & Bulk',
};
